import { IWatchesState } from './watchesContext';
import { WatchesActionsTypes, TWatchesAction } from './watchesAction';

export const watchesReducer = (state: IWatchesState, action: TWatchesAction): IWatchesState => {
	switch (action.type) {
		case WatchesActionsTypes.SET_WATCHES_QUANTITY:
			return {
				...state,
				watchesQuantity: action.payload.watchesQuantity,
				watchesTableRanges: action.payload.watchesTableRanges,
			};
		case WatchesActionsTypes.SET_ADMIN_WATCHES_QUANTITY:
			return {
				...state,
				adminWatchesQuantity: action.payload.adminWatchesQuantity,
				adminWatchesTableRanges: action.payload.adminWatchesTableRanges,
			};
		case WatchesActionsTypes.SET_COMMANDS:
			return {
				...state,
				commands: action.payload.commands,
			};
		case WatchesActionsTypes.CHANGE_WATCHES_TABLE_RANGES:
			return {
				...state,
				watchesTableRanges: action.payload.watchesTableRanges,
			};
		case WatchesActionsTypes.CHANGE_ADMIN_WATCHES_TABLE_RANGES:
			return {
				...state,
				adminWatchesTableRanges: action.payload.adminWatchesTableRanges,
			};
		case WatchesActionsTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case WatchesActionsTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
